import * as http from "@/utils/request";
import {jsonToFormData} from "@/utils";


 
//查询列表 GET /DeviceOrder/findList
export  const findList =(params)=>{
    return http.get('/DeviceOrder/findList',params)
  }


//查询列表 GET /DeviceOrder/findList
export  const loadAllOrderByModuleModel =(params)=>{
  return http.get('/DeviceOrder/loadAllOrderByModuleModel',params)
}


//新增 POST /DeviceOrder/insert
export function add(params){
    return http.postJSON("/DeviceOrder/insert",params);
  }

  //编辑POST /DeviceOrder/update
  export function update(params){
    return http.postJSON("/DeviceOrder/update",params);
  }

  //导出GET /DeviceOrder/exportExcel
  export function exportExcel(params) {
    return http.getExcel("/DeviceOrder/exportExcel",params,"导出")
 }
 //GET /DeviceOrder/loadAllOrder
 export  const loadAllOrder =(params)=>{
  return http.get('/DeviceOrder/loadAllOrder',params)
}


//成品库存管理 GET /finishedInventory/findPage
export  const findPage =(params)=>{
  return http.get('/finishedInventory/findPage',params)
}

//设备类型选择 GET /repe/repe/findTypeList
export  const findTypeList =(params)=>{
  return http.get('/repe/repe/findTypeList',params)
}

//删除 POST /repe/repe/delete
export function deletes(params){
  return http.postJSON("/DeviceOrder/delete?"+jsonToFormData(params),{});
}


//技术确认 POST /DeviceOrder/technicalConfirmation
export function technicalConfirmation(params){
  return http.postJSON("/DeviceOrder/technicalConfirmation",params);
}


//导出 GET GET /DeviceOrder/exportExcel
export function detailExportExcel(params) {
  return http.getExcel("/DeviceOrder/exportExcel",params,"导出")
}


//订单日志 DeviceOrder/findLogPage
export function findLogPage({id,page,size}){
  return http.get('DeviceOrder/findLogPage',{id,page,size})
}


//调整新增 /DeviceOrder/insertTechnical
export function insertTechnical(params){
  return http.postJSON("/DeviceOrder/insertTechnical",params);
}

//修改订单数量 DeviceOrder/updateOrderNum
export function updateOrderNum(params){
  return http.postJSON("DeviceOrder/updateOrderNum?"+jsonToFormData(params),{});
}



//待升级订单 GET /upgradeMission/findPageByNotOrder
export function findPageByNotOrder(page,params){
  return http.postJSON('/upgradeMission/findPageByNotOrder?'+jsonToFormData(page),params)
}


// WEBPACK FOOTER //
// ./src/services/deviceOrder.js